import styled, { keyframes } from "styled-components";

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const PromptCreateViewContainer = styled.div`
  display: flex;
  width: 100%;
  height: calc(100vh - 390px);
`;

export const LeftColumn = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
`;

export const RightColumn = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60vh;
  flex-direction: column;
  width: 100%;
`;

export const CustomSpinner = styled.div`
  width: 40px;
  height: 40px;
  border: 3px solid ${(props) => props.theme.colors.clearGray};
  border-top: 3px solid ${(props) => props.theme.colors.black};;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

export const LoadingText = styled.div`
  margin-top: 16px;
  font-size: 14px;
  color: #666;
  font-weight: 400;
`;